import { Grid, Rating, Stack, Typography } from '@mui/material';
import React from 'react';
import { colors } from '../utils/theme';
import { Review } from '../types';

export const ReviewContent = ({ review }: { review: Review }): JSX.Element => {
  return (
    <Grid container flexDirection="column">
      <Stack>
        <Rating
          name="user-review"
          value={review.rating}
          size="small"
          precision={0.5}
          sx={{ color: colors.yellows.YELLOW_500 }}
        />
      </Stack>

      <Typography
        sx={{
          fontWeight: 500,
          color: colors.greys.BASE_WHITE,
          mt: 3,
          mb: 4,
          fontSize: { xs: 20, md: 32 },
        }}
      >
        {review.review}
      </Typography>
      <Typography
        fontSize={18}
        sx={{ fontWeight: 500, color: colors.greys.BASE_WHITE, mb: 0.5 }}
      >
        - {review.author.name}
      </Typography>
      {review.author.title && (
        <Typography fontSize={12} sx={{ color: colors.greys.SILVER }}>
          {review.author.title.toUpperCase()}
        </Typography>
      )}
    </Grid>
  );
};
